(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dc-google-reviews"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dc-review-strip')){
customElements.define('dc-review-strip',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.index=0;this.slides=[...this.querySelectorAll('.dcr-slide')];this.pauseButton=this.querySelector('[data-pause]');
this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.show=(step)=>{this.slides[this.index].hidden=true;this.index=(this.index+step+this.slides.length)%this.slides.length;this.slides[this.index].hidden=false};
this.update=()=>{this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel)};
this.querySelector('[data-prev]').onclick=()=>{this.paused=true;this.update();this.show(-1)};
this.querySelector('[data-next]').onclick=()=>{this.paused=true;this.update();this.show(1)};
this.pauseButton.onclick=()=>{this.paused=!this.paused;this.update()};
this.addEventListener('touchstart',e=>{this.touchX=e.changedTouches[0].clientX},{passive:true});
this.addEventListener('touchend',e=>{let d=e.changedTouches[0].clientX-this.touchX;if(Math.abs(d)>45){this.paused=true;this.update();this.show(d<0?1:-1)}},{passive:true});
this.update();this.timer=setInterval(()=>{if(!this.paused&&!this.querySelector('details[open]')&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.show(1)},8500);
}
disconnectedCallback(){clearInterval(this.timer);this.ready=false}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dc-work-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('dc-work-gallery'))customElements.define('dc-work-gallery',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;const track=this.querySelector('.dcwg-track'),modal=this.querySelector('dialog'),large=this.querySelector('.dcwg-large');
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
this.querySelector('[data-prev]').onclick=()=>track.scrollBy({left:-track.clientWidth,behavior:reduced?'instant':'smooth'});
this.querySelector('[data-next]').onclick=()=>track.scrollBy({left:track.clientWidth,behavior:reduced?'instant':'smooth'});
this.querySelectorAll('[data-photo]').forEach(b=>b.onclick=()=>{const img=b.querySelector('img').cloneNode();img.loading='eager';large.replaceChildren(img);large.style.setProperty('--photo-ratio','600 / '+b.dataset.height);large.style.setProperty('--photo-top',(-Number(b.dataset.top)/Number(b.dataset.height)*100)+'%');this.querySelector('.dcwg-modal-caption').textContent=img.alt;modal.showModal()});
this.querySelector('[data-close]').onclick=()=>modal.close();
modal.addEventListener('click',e=>{if(e.target===modal){const r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)modal.close()}});
}
});
  } catch(e) { console.error(e); }
})();

})();
